import { cn } from "@omni/utils/styles";

import { FamiliesSkeleton } from "@/components/PaintConfigurator/components/colors/components/filters/components/families/families.skeleton";
import { FilterButton } from "@/components/PaintConfigurator/components/shared/filter/filterButton";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { withBreakpoints } from "@/utils/breakpoints/breakpoints.provider";
import { useSkeleton } from "@/utils/hooks/useSkeleton.hook";

import { useColorsContext } from "../../../../context/colors.context";

type Props = {
    className?: string;
};

const _Families = ({ className }: Props) => {
    const { t } = useGranite();
    const { families, setSelectedFamily, selectedFamily, loadingFamilies } =
        useColorsContext();

    const { showSkeleton, showContent } = useSkeleton(loadingFamilies);

    return (
        <div className={cn("tw:flex tw:flex-col tw:gap-2", className)}>
            <div className={cn("tw:font-bold")}>
                {t("paintConfigurator.color.filters.families.title")}
            </div>
            <ul className={cn("tw:flex tw:gap-2 tw:flex-wrap tw:mb-0")}>
                {showContent &&
                    families.map((family) => (
                        <li
                            key={family.id}
                            className={cn("")}
                        >
                            <FilterButton
                                onClick={() => setSelectedFamily(family.id)}
                                isSelected={family.id === selectedFamily?.id}
                                label={family.name}
                            >
                                <span
                                    style={{
                                        backgroundColor: family.hex
                                    }}
                                    className={cn(
                                        "tw:inline-block tw:mr-2 tw:w-2 tw:h-2 tw:rounded-full tw:relative tw:bottom-0.5"
                                    )}
                                ></span>
                                <span className={cn("tw:inline-block")}>
                                    {family.name}
                                </span>
                            </FilterButton>
                        </li>
                    ))}
                {showSkeleton && <FamiliesSkeleton />}
            </ul>
        </div>
    );
};

export const Families = withBreakpoints(_Families);
